exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] .zrDO3DkKqPus8hgrGPs9B{padding:20px;background:\"[theme:white, default:#ffffff]\"}", ""]);

// exports
exports.locals = {
	"spinner": "zrDO3DkKqPus8hgrGPs9B"
};